/**
 * Created by AI assistant on 13.02.26.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareLinkedEntity } from '../fw/MetaDataHelper.ts';
import * as Permission from '../util/Permission';
import { markdownDocVisibility } from './FlowDefMarkdownDocType';

export default declareLinkedEntity({
    entity: "channelDefMarkdownDocs",
    graphQL: "ChannelDefMarkdownDoc",
    name: "Channel Definition Markdown Documentation",
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    parentRelation: "channelDefMarkdownDocs",
    defaultTitle: (data) => {
        return data['title'] || data['key'];
    },
    isPublic: true,
    dynamoPrefix: 'def',
    storageType: 'schema',
    onModify: ['channelDef'],
    fields: (types) => { return {
        id: {
            name: "Channel Definition Markdown Documentation ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
            compositeKey: true,
        },
        channelDef: {
            name: "Channel Definition",
            to: () => types['channelDefs'],
            type: "relation",
            defaultValue: (channelDef) => {
                return channelDef['id'];
            },
            required: true,
            parent: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        channelDefVersion: {
            name: "Channel Definition Version",
            to: () => types['channelDefVersions'],
            type: "relation",
            defaultValue: (channelDef) => {
                return channelDef['channelDefVersion_id'];
            },
            required: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        key: {
            name: "Key",
            type: "string",
            defaultValue: "",
            trim: true,
        },
        title: {
            name: "Title",
            type: "string",
            translatable: false,
            defaultValue: "",
        },
        content: {
            name: "Markdown Content",
            type: "text",
            translatable: false,
            defaultValue: "",
        },
        order: {
            name: "Order",
            type: "int",
            defaultValue: 0,
        },
        visibility: {
            name: "Visibility",
            type: "enum",
            defaultValue: "internal",
            values: markdownDocVisibility,
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; },
    relations: () => { return {
    }; }
});
